<template>
    <div
        class="md-team carousel"
        v-if="allTotal > 0"
        :style="{
            backgroundColor: bgColor,
            color: bgColor,
            paddingTop,
            marginBottom
        }"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            :noMargin="true"
            :noPadding="true"
        >
            <div class="mg-title" v-if="fmtTitle" v-html="formatFontSize(fmtTitle, '--mg-title-size')"></div>
            <div class="agents-container">
                <div
                    v-if="agents.length > useSlidesPerView"
                    class="left-mask"
                ></div>
                <div
                    v-if="agents.length > useSlidesPerView"
                    class="right-mask"
                ></div>
                <swiper
                    v-if="
                        agents.length > useSlidesPerView && sliderShow
                    "
                    class="slider-container"
                    :style="{ backgroundColor: bgColor }"
                    v-bind="options"
                >
                    <slide
                        v-for="agent in agents"
                        :key="agent.id"
                        class="agent-item"
                        :class="{ mobile: isMobileSize }"
                    >
                        <agent-item
                            :agent="agent"
                            :licenseName="licenseName"
                            :detailUrlTarget="detailUrlTarget"
                        >
                        </agent-item>
                    </slide>
                </swiper>
                <div
                    v-if="agents.length <= useSlidesPerView"
                    class="agent-list"
                    :class="{ center: agents.length <= 2 }"
                >
                    <div
                        v-for="(agent, index) in agents"
                        :key="agent.id"
                        class="agent-item"
                        :class="{ mobile: isMobileSize }"
                        :style="{
                            width: `calc(100% / ${useSlidesPerView} - ${
                                ((useSlidesPerView - 1) * useAgentItemSpace) /
                                useSlidesPerView
                            }px)`,
                            marginRight:
                                index < agents.length - 1
                                    ? useAgentItemSpace + 'px'
                                    : '0'
                        }"
                    >
                        <agent-item
                            :agent="agent"
                            :licenseName="licenseName"
                            :detailUrlTarget="detailUrlTarget"
                        >
                        </agent-item>
                    </div>
                </div>
                <i
                    v-if="agents.length > useSlidesPerView"
                    class="iconfont icon-prev prev-el"
                ></i>
                <i
                    v-if="agents.length > useSlidesPerView"
                    class="iconfont icon-next next-el"
                ></i>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
import carousel from '../carousel';
import agentItem from './agent-item.vue';
import { normal } from '../../defaultSpacing';

export default {
    mixins: [common, carousel],
    components: {
        agentItem
    },
    data: function() {
        return {
            ...normal
        };
    },
    computed: {
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) + 'px'
            );
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        }
    }
};
</script>

<style lang="scss">
@import './carousel.scss';

.md-team.carousel {
    background-color: #ffffff;
    color: #fff;
    @include carousel-common();
}
</style>
